import React from 'react'
import { connect } from 'react-redux'
import { history } from '../../routers/AppRouter'
import firebase from '../../utils/firebase'
import moment from 'moment'
import { Container, Grid, IconButton, ButtonGroup, Button, CircularProgress, Typography, Card, CardContent, Divider, Chip } from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/Receipt';
import ShoppingCartOutlinedIcon from '@material-ui/icons/ShoppingCartOutlined';
import AllInboxOutlinedIcon from '@material-ui/icons/AllInboxOutlined';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import ExpandLessOutlinedIcon from '@material-ui/icons/ExpandLessOutlined';
import StorefrontIcon from '@material-ui/icons/Storefront';
import LocationOnOutlinedIcon from '@material-ui/icons/LocationOnOutlined';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
    loading: {
        width: '100%',
        textAlign: 'center',
        marginTop: theme.spacing(4)
    },
    orderPage: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        minHeight: '50vh'
    },
    card: {
        marginBottom: theme.spacing(2),
        borderRadius: '20px',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& >*': {
            marginRight: theme.spacing(1)
        },
        [theme.breakpoints.between('xs', 'sm')]: {
            '& >*': {
                marginRight: 0
            }
        },
        [theme.breakpoints.only("xs")]: {
            '& >*': {
                marginRight: 0
            }
        },
    },
    gridRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(1)
    },
    ellipses: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        paddingLeft: '10px',
        '& >*': {
            marginTop: '-18px',
        }
    },
    marginTop: {
        marginTop: theme.spacing(1)
    },
    marginBottom: {
        marginBottom: theme.spacing(1)
    },
    marginBottomLg: {
        marginBottom: theme.spacing(3)
    }
}));


const LiveOrders = (props) => {

    const classes = useStyles();

    const { loading, orders, liveOrders } = props

    const [selected, setSelected] = React.useState(null)

    if (loading) {
        return (<Container className={classes.orderPage}>
            <div className={classes.loading}>
                <CircularProgress color="secondary" />
            </div>
        </Container>)
    }


    function renderCart(cart) {

        const cartArrayUi = []

        for (let key in cart) {
            const itemArray = cart[key]
            let itemUi = itemArray.map((config) => {
                return (
                    <Grid item xs={12} id={config.configId} key={config.configId}>
                        <Card>
                            <CardContent style={{ padding: '5px' }}>
                                <Grid container >
                                    <Grid item xs={7}>
                                        <Typography aria-label={config.title} component="div" variant="body2" align="left" color="primary" style={{ textTransform: 'capitalize' }}>
                                            {config.title.toLowerCase()}
                                        </Typography>

                                        {
                                            Object.keys(config.customization).length > 0 &&
                                            <><strong style={{ fontSize: "10px", color: "#56595a", padding: "0px" }}>{Object.keys(config.customization).length} ADD ON :</strong> <br></br> </>
                                        }
                                        {

                                            Object.keys(config.customization).map((key, index) => {
                                                const addon = config.customization[key]
                                                const len = Object.keys(config.customization).length
                                                return <span style={{ color: "#56595a", fontSize: "10px" }} key={addon.id}>{addon.name}
                                                    {index <= len - 2 && <span> | </span>}
                                                </span>
                                            })
                                        }


                                    </Grid>
                                    <Grid item xs={5} style={{ textAlign: "right" }}>
                                        <Typography aria-label={config.price} component="div" variant="body2" align="right" color="primary">
                                            ₹{parseInt(config.totalPrice) * parseInt(config.quantity)} {' QTY'} {parseInt(config.quantity)}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                )
            })

            cartArrayUi.push(itemUi)
        }

        return cartArrayUi

    }

    function renderPayment(paymentDetails) {
        return (
            <Grid item xs={12} className={classes.marginTop} >
                <Card>
                    <CardContent style={{ padding: '5px 5px 0 5px' }}>
                        <div className={classes.gridRow} >
                            <Typography component="div" variant="body2" align="left" color="primary" >
                                Item Price
                                         </Typography>
                            <Typography component="div" variant="body2" align="right" color="primary" >
                                ₹{Number(paymentDetails.itemPrice).toFixed(2)}
                            </Typography>
                        </div>
                        {paymentDetails.discount > 0 && (<div className={classes.gridRow} >
                            <Typography component="div" variant="body2" align="left" color="primary" >
                                Discount
                                         </Typography>
                            <Typography component="div" variant="body2" align="right" color="primary" >
                                - ₹{Number(paymentDetails.discount).toFixed(2)}
                            </Typography>
                        </div>)}
                        <div className={classes.gridRow} >
                            <Typography component="div" variant="body2" align="left" color="primary" >
                                Packaging Charge
                                         </Typography>
                            <Typography component="div" variant="body2" align="right" color="primary" >
                                + ₹{Number(paymentDetails.packagingCharge).toFixed(2)}
                            </Typography>
                        </div>
                        <div className={classes.gridRow} >
                            <Typography component="div" variant="body2" align="left" color="primary" >
                                Delivery Charge
                                         </Typography>
                            <Typography component="div" variant="body2" align="right" color="primary" >
                                + ₹{Number(paymentDetails.deliveryCharge).toFixed(2)}
                            </Typography>
                        </div>
                        <div className={classes.gridRow} >
                            <Typography component="div" variant="body2" align="left" color="primary" >
                                GST {Number(paymentDetails.gst)}%
                                         </Typography>
                            <Typography component="div" variant="body2" align="right" color="primary" >
                                + ₹{(Number(paymentDetails.itemPrice) * (Number(paymentDetails.gst)) / 100).toFixed(2)}
                            </Typography>
                        </div>
                        <div className={classes.gridRow} >
                            <Typography component="span" variant="body2" align="left" color="primary"> <strong> GRAND TOTAL </strong></Typography>
                            <Typography component="span" variant="body2" align="right" color="primary"><strong>₹{Number(paymentDetails.orderAmount).toFixed(2)} </strong> <div>( {paymentDetails.paymentMode} )</div></Typography>
                        </div>

                    </CardContent>
                </Card>
            </Grid>
        )
    }

    function renderCard(id) {
        const order = orders[id]
        const { deliveryLocationInfo, deliveryPerson, deliveryPersonAssigned, orderCart, orderLive, orderOutlet, orderUser, orderedAt, paymentDetails, status } = order

        const statusMap = {
            ORDER_PLACED: 'ORDER PLACED',
            ORDER_ACCEPTED: 'ORDER ACCEPTED',
            ORDER_CANCLED: 'ORDER CANCELLED',
            FOOD_BEING_PREPARED: 'FOOD BEING PREPARED',
            ORDER_ON_THE_WAY: 'ORDER ON THE WAY',
            DELIVERED: 'COMPLETED'
        }

        const timestamp = new firebase.firestore.Timestamp(orderedAt.seconds, orderedAt.nanoseconds)

        const date = moment(timestamp.toDate()).format('DD MMM YY, h:mm a')

        return (
            <Card className={classes.card} variant="outlined" id={id}>
                <CardContent>
                    <Grid container justify="space-between" className={classes.marginBottom}>
                        <Grid item className={classes.row}>
                            <ReceiptIcon />
                            <Typography variant="body2" component="p" ><strong>{paymentDetails.orderId} </strong></Typography>
                            <Typography variant="caption" component="p" color="error" >{statusMap[status]}</Typography>
                            <Typography variant="caption" component="p" color="textSecondary" >{date.toString()} </Typography>
                        </Grid>
                        <Grid item >
                            {orderLive && <Chip
                                label="Live"
                                color="secondary"
                            />}
                        </Grid>
                    </Grid>

                    <Divider />

                    <Grid container justify="space-between" className={`${classes.marginBottom} ${classes.marginTop}`}>
                        <Grid item className={classes.row} xs={12}>
                            <StorefrontIcon />
                            <Typography variant="body1" component="p" >{orderOutlet.address.extra_info} {' '} {orderOutlet.address.location} </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <div className={classes.ellipses}>
                                <Typography variant="body1" component="p" className={classes.zero} > <strong> . </strong></Typography>
                                <Typography variant="body1" component="p" className={classes.zero}> <strong> . </strong></Typography>
                                <Typography variant="body1" component="p" className={classes.zero} > <strong> . </strong></Typography>
                            </div>
                        </Grid>
                        <Grid item className={classes.row} xs={12}>
                            <LocationOnOutlinedIcon />
                            <Typography variant="body1" component="p" >
                                {deliveryLocationInfo.doorNumber} {' '} {deliveryLocationInfo.landmark} {' '} {deliveryLocationInfo.address}
                                {' | '} {deliveryLocationInfo.name && `${deliveryLocationInfo.name} - `}
                                {deliveryLocationInfo.phoneNumber && deliveryLocationInfo.phoneNumber}
                            </Typography>
                        </Grid>
                    </Grid>

                    <Divider />

                    <Grid container justify="space-between" className={`${classes.marginBottom} ${classes.marginTop}`}>
                        <Grid item className={classes.row} xs={12}>
                            <AllInboxOutlinedIcon />
                            <Typography variant="body1" component="p" color="textSecondary">Delivery Partner</Typography>
                        </Grid>
                        <Grid item xs={12} className={classes.marginTop}>
                            <Typography variant="body1" component="p">{deliveryPerson.name && deliveryPerson.name} {deliveryPerson.phone && deliveryPerson.phone}</Typography>
                        </Grid>
                    </Grid>

                    <Divider />
                    {selected === id ? <React.Fragment>
                        <Grid container justify="space-between" className={classes.marginTop}>
                            <Grid item xs={12} className={classes.gridRow}>
                                <div className={classes.row}>
                                    <ShoppingCartOutlinedIcon />
                                    <Typography variant="body1" component="p" color="textSecondary">Ordered Items</Typography>
                                </div>
                                <IconButton onClick={() => setSelected(null)}> <ExpandLessOutlinedIcon /> </IconButton>
                            </Grid>
                            {renderCart(orderCart)}
                            {renderPayment(paymentDetails)}
                        </Grid>
                    </React.Fragment>
                        :
                        <div className={classes.gridRow} style={{ marginBottom: '-20px' }}>
                            <div className={classes.row}>
                                <Typography variant="body1" component="span"><strong>Total: ₹{Number(paymentDetails.orderAmount).toFixed(2)}</strong>
                                    <Typography variant="subtitle2" component="div">
                                        Payment Method : {paymentDetails.paymentMode}
                                    </Typography>
                                </Typography>
                            </div>
                            <IconButton onClick={() => setSelected(id)} ><ExpandMoreOutlinedIcon /></IconButton>
                        </div>
                    }
                </CardContent>
            </Card>
        )
    }

    return (
        <Container className={classes.orderPage}>
            <Grid container justify="center" >
                <Grid item sm={6} xs={12}>
                    <ButtonGroup fullWidth variant="contained" className={classes.marginBottomLg}>
                        <Button color="primary" onClick={() => history.push('/live-orders')} >Live Orders</Button>
                        <Button onClick={() => history.push('/past-orders')}  >Past Orders</Button>
                    </ButtonGroup>
                    {
                        liveOrders.length === 0 ?
                            <Typography variant="body1" color="error" component="p" align="center" >No current orders</Typography>
                            :
                            <div>
                                <Typography variant="subtitle1" component="p">Hurray!!! Your order has been placed with us. Below are the details of your order.</Typography>
                                {liveOrders.map(id => <React.Fragment key={id}> {renderCard(id)}</React.Fragment>)}
                                <Typography variant="subtitle1" component="p">Call our customer support team for any issue or cancellation.</Typography>
                            </div>
                    }
                </Grid>
            </Grid>
        </Container>
    )


}

const mapStateToProps = (state) => {
    const myOrders = state.myOrders
    const { orders, liveOrders } = myOrders
    return {
        loading: myOrders.loading,
        orders, liveOrders
    }
}

export default connect(mapStateToProps, {})(LiveOrders)